'use client'

import { useSetAtom } from 'jotai'
import { useCallback } from 'react'

import { type ArbDialogLegSeed, arbDialogOpenAtom, arbDialogSeedAtom } from '@/state/widget-actions'

// No open-guard needed (unlike Hedge, which checks "any positions to hedge") — an arb isn't
// position-driven, it's always a fresh two-leg quote setup.
export function useOpenArbDialog() {
  const setOpen = useSetAtom(arbDialogOpenAtom)
  const setSeed = useSetAtom(arbDialogSeedAtom)
  return useCallback(
    (seed?: { leg1?: ArbDialogLegSeed; leg2?: ArbDialogLegSeed }) => {
      setSeed(seed ?? null)
      setOpen(true)
    },
    [setOpen, setSeed]
  )
}
